import React, { useState } from "react";
import { Box, Button, Card, Modal, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { KeywordForm, KeywordList, KeywordModalCreate } from "./";
import { ManagementLayout } from "@components/shared";
import KeywordFormSetup from "./KeywordFormSetup";

export default function KeywordManagement({
  additionalCreateData = {},
  campaignId,
  contestId,
  effortId,
  locationId,
  organizationId,
  minStartDate,
  maxEndDate,
  showCreate = true,
  showModalCreate = false,
}) {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const req = {
    refresh,
  };

  if (effortId) req.campaign_effort_id = effortId;
  if (campaignId) req.campaign_id = campaignId;
  if (contestId) req.contest_id = contestId;
  if (organizationId) req.organization_id = organizationId;
  if (locationId) req.location_id = locationId;

  if (!showCreate) {
    return (
      <div>
        {showModalCreate && (
          <Box mb="sm">
            <KeywordModalCreate
              effortId={effortId}
              locationId={locationId}
              organizationId={organizationId}
              maxEndDate={maxEndDate}
              onSuccess={() => setRefresh(!refresh)}
            />
          </Box>
        )}
        <KeywordList
          refresh={refresh}
          requestInfo={{
            url: `/retrieve-keywords/`,
            data: req,
          }}
        />
      </div>
    );
  }

  return (
    <ManagementLayout
      dataComponent={
        <KeywordList
          refresh={refresh}
          requestInfo={{
            url: `/retrieve-keywords/`,
            data: req,
          }}
        />
      }
      createComponent={
        <Card
          style={{
            overflow: "visible",
          }}
        >
          <Title order={4}>{t("mixer:keyword:create_keyword")}</Title>
          {!organizationId && !locationId ? (
            <KeywordForm
              additionalReqData={additionalCreateData}
              campaignId={campaignId}
              contestId={contestId}
              effortId={effortId}
              minStartDate={minStartDate}
              maxEndDate={maxEndDate}
              onSuccess={() => setRefresh(!refresh)}
            />
          ) : (
            <KeywordFormSetup
              locationId={locationId}
              organizationId={organizationId}
              onSuccess={() => setRefresh(!refresh)}
            />
          )}
        </Card>
      }
    />
  );
}
